import { render } from "./ReloadHelper.vue?vue&type=template&id=811a8bfe"
import script from "./ReloadHelper.vue?vue&type=script&lang=js"
export * from "./ReloadHelper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__